import { getStepsForProgram } from '@/constants/programStepsConfig';
import {
  ADMIN_ROLES,
  CLINICAL_ROLES,
  INTERNAL_STAFF_ROLES,
  SENIOR_ADMIN_ROLES,
} from '@/utils/roles';
import { ProgramSteps } from './types';

export { ADMIN_ROLES, CLINICAL_ROLES, INTERNAL_STAFF_ROLES, SENIOR_ADMIN_ROLES };

export const toTitleCase = (str: string | null): string => {
  if (!str) return '';
  return str
    .split(/[\s_]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatRole = (role: string | null): string => {
  if (!role) return 'User';
  return toTitleCase(role);
};

export const calculateProgramProgress = (
  programSteps: ProgramSteps,
  programName: string,
  showIntakeCall?: boolean,
  addonNames?: string[]
): { completed: number; total: number; progressText: string } => {
  const allowedSteps = getStepsForProgram(programName);

  const filteredAllowedSteps = allowedSteps.filter((stepId) => {
    if (stepId === 'intake_call' && !showIntakeCall) {
      return false;
    }

    if (stepId === 'in_center' && programName.toUpperCase().includes('FOUNDATION')) {
      const addOns = addonNames || [];
      if (addOns.length < 2) {
        return false;
      }
    }

    return true;
  });

  const totalSteps = filteredAllowedSteps.length;
  const completedSteps = filteredAllowedSteps.filter(
    (stepId) => programSteps[stepId as keyof ProgramSteps] === 'true'
  ).length;

  return {
    completed: completedSteps,
    total: totalSteps,
    progressText: `${completedSteps}/${totalSteps}`,
  };
};
